import { render, staticRenderFns } from "./TsModalCloseButton.vue?vue&type=template&id=2376264e&"
import script from "./TsModalCloseButton.vue?vue&type=script&lang=js&"
export * from "./TsModalCloseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports